import generateCksId from './generateCksId';
import getFormProps from './getFormProps';

/**
 * Gets form confirmation metrics for `digitaldata` by tracking ID.
 * @param {string} formTrackingId The form tracking ID.
 * @param {string} formMapping The form mappings
 * @returns {Object} Form confirmation metrics.
 */
export default ({ formMapping, formTrackingId }) => {
	const data = getFormProps({
		formMapping,
		formTrackingId,
		isConfirm: true
	});

	// TODO: The stuff below can probaly just be moved to getFormProps since that function is aware of confirmation pages as well
	// Might not even need buildFormConfirmationData (this file).

	if (typeof data === 'object') {
		// apply CKS Visit ID for lead confirmation
		data.user = data.user || {};
		data.user.cksVisitId = generateCksId(data.cksCode);

		// delete email opt-in flag if no user email provided
		if (
			data.user.leadOptIn &&
			!window?.DDC?.dataLayer?.confirmation?.email
		) {
			delete data.user.leadOptIn;
		}

		// remove non-digitaldata props and merge form data
		delete data.directCall;
		delete data.cksCode;
	}

	/*
	// one of the pages this code is for got 1 hit in the last month (ddctimb - 6/11/2024)
	// https://onenr.io/0OwvMnXPDQv

	// If why buy or black label then get nameplate from formAlias
	const formCustomTracking =
		window?.DDC?.dataLayer?.confirmation?.customFormId;

	if (formCustomTracking) {
		let nameplate;

		if (formCustomTracking.includes('why-buy')) {
			nameplate = `lincoln ${formCustomTracking.split('-')[2]}`;
		} else if (formCustomTracking.includes('bl19-')) {
			nameplate = `lincoln ${formCustomTracking.split('-')[1]}`;
		}

		if (nameplate) {
			data.vehicle = data.vehicle || {};
			data.vehicle.nameplate = nameplate;
			data.page = data.page || {};
			data.page.pageName += `:${nameplate}`;
		}
	}
	*/

	// Idempotent, like derivePageNames' own prefix(): a config value that already
	// carries `dc:` must not be prefixed twice. Config is not supposed to include
	// it (the four SITEBUILDER_BLUECRUISE_1-contact values that did emitted
	// `dc:dc:bluecruise:...` live), but guarding here means a future one cannot
	// reintroduce the bug.
	if (data?.page?.pageName && !data.page.pageName.startsWith('dc:')) {
		data.page.pageName = `dc:${data.page.pageName}`;
	}

	return data;
};
